import request from '@/utils/request';

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username, password, code, uuid
  };
  return request({
    'url': '/login', headers: {
      isToken: false
    }, 'method': 'post', 'data': data
  });
}

export function loginByWeiXin(query) {
  return request({
    url: '/loginByWeiXin',
    headers: {
      isToken: false
    },
    method: 'get',
    params: query
  });
}

// 注册方法
export function register(data) {
  return request({
    url: '/register', headers: {
      isToken: false
    }, method: 'post', data: data
  });
}

// 获取用户详细信息
export function getInfo() {
  return request({
    'url': '/getInfo', 'method': 'get'
  });
}

// 退出方法
export function logout() {
  return request({
    'url': '/logout', 'method': 'post'
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    'url': '/captchaImage', headers: {
      isToken: false
    }, method: 'get', timeout: 20000
  });
}

// 获取手机号验证码
export function captchaPhone(params) {
  return request({
    url: '/captchaPhone', headers: {
      isToken: false
    }, method: 'get', params: params
  });
}

export function captchaResetPasswordPhone(params) {
  return request({
    url: '/captchaResetPasswordPhone', headers: {
      isToken: false
    }, method: 'get', params: params
  });
}
